import { Component } from 'react';
import { Provider } from 'react-redux';
import { Route } from 'quartz-routing/react-router';
import { setPrimaryTracker } from 'usage-tracker-container';
import Raven from 'raven-js';
import { dataFetchingClient } from './utils/DataFetchingClient';
// @ts-ignore untyped
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
// @ts-ignore untyped
import HierarchicalTeamReferenceResolver from 'reference-resolvers/resolvers/HierarchicalTeamReferenceResolver';
// @ts-ignore untyped
import * as ReferenceObjectTypes from 'reference-resolvers/constants/ReferenceObjectTypes';
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import { ACAppShell } from 'academy-common-lib/components/ACAppShell';
import Routes from './routes';
import { configureStore } from './utils/configureStore';
import UsageTracker from './utils/UsageTracker';
import { handleInternalReferral } from './utils/RoutingUtils.migrated';
import ACBadRequestError from 'academy-common-lib/components/error/ACBadRequestError';
import { PlaylistSurvey } from './features/savedItems/components/PlaylistSurvey';
import { GatedAcademyAssistantShell } from './components/GatedAcademyAssistantShell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ACADEMY_IFRAME_INITIATED = 'academy-iframe-initiated';
if (window.self !== window.top) {
  window.parent.postMessage(ACADEMY_IFRAME_INITIATED, window.location.origin);
}
class LearningCenter extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidMount() {
    this.handlePossibleReferral();
    setPrimaryTracker(UsageTracker.standaloneTracker);
  }
  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, {
      extra: errorInfo
    });
  }
  handlePossibleReferral() {
    handleInternalReferral({
      href: window.location.href,
      sendTracking: data => {
        UsageTracker.track('interaction', Object.assign({
          action: 'internal-referral'
        }, data));
      },
      replacePath: newPath => window.history.replaceState(null, '', newPath)
    });
  }
  render() {
    const {
      hasError
    } = this.state;
    if (hasError) {
      return /*#__PURE__*/_jsx(ACBadRequestError, {});
    }
    const {
      gates,
      portalId,
      scopes,
      user
    } = this.props;
    const email = user.email || user.emails && user.emails[0];
    const store = configureStore({
      auth: {
        user: {
          user_id: user.id,
          email,
          firstName: user.firstName,
          lastName: user.lastName,
          verifiedAt: user.verifiedAt,
          locale: user.locale,
          langEnabled: user.languageEnabled
        },
        portal: {
          portal_id: portalId
        },
        gates,
        scopes
      }
    });
    return /*#__PURE__*/_jsx(ACAppShell, {
      dataFetchingClient: dataFetchingClient,
      children: /*#__PURE__*/_jsx(Provider, {
        store: store,
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(PlaylistSurvey, {}), /*#__PURE__*/_jsx(Route, {
            children: ({
              history
            }) => /*#__PURE__*/_jsx(RhumbProvider, {
              config: rhumbConfig,
              history: historyAdapter(history),
              children: /*#__PURE__*/_jsx(GatedAcademyAssistantShell, {
                children: /*#__PURE__*/_jsx(Routes, {})
              })
            })
          })]
        })
      })
    });
  }
}
export default ProvideReferenceResolvers({
  [ReferenceObjectTypes.HIERARCHICAL_TEAM]: HierarchicalTeamReferenceResolver
}, LearningCenter);